import { render, staticRenderFns } from "./ContractsAndResponsibilitiesManagement.vue?vue&type=template&id=0ae7bc90&scoped=true"
import script from "./ContractsAndResponsibilitiesManagement.vue?vue&type=script&lang=js"
export * from "./ContractsAndResponsibilitiesManagement.vue?vue&type=script&lang=js"
import style0 from "./ContractsAndResponsibilitiesManagement.vue?vue&type=style&index=0&id=0ae7bc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae7bc90",
  null
  
)

export default component.exports